import { createSlice } from "@reduxjs/toolkit";
import { CompanyChargeResponseDto } from "../../shared/dtos/companyCharge/CompanyChargeResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

const companyChargeSlice = createSlice({
  name: "companyCharge",
  initialState: getInitialCrudState<CompanyChargeResponseDto>(),
  reducers: { ...generateCrudReducers<CompanyChargeResponseDto>() },
});

export const companyChargeActions = companyChargeSlice.actions;
export default companyChargeSlice.reducer;
